export function PalavrasLogo() {
  return <img className="palavras-logo" src="/brands/palavras/logo.png"
    alt="Palavras Educação" width="350" height="100" />
}
